export default __webpack_public_path__ + "static/media/Max.eb62f3c1.svg";